import LessonIcon from 'img/icons/offering_icons/lesson_labplus_icon.svg';
import {
  BodyRowType,
  HeaderIconConfig,
  IconLabel,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';

const lessonIconConfig: HeaderIconConfig = {
  backgroundColor: '#4E745C',
  iconTitle: 'Delivery format: Lesson',
  src: LessonIcon,
};

const lessonConfig: OfferingTypeConfig = {
  actionButtons: ({ displayProgress, entry, hasProgress, catalogStore, t }) => {
    const link = catalogStore.getCatalogEntryLink(entry, { hasProgress });
    if (!link) {
      return {};
    }

    return {
      actionButtonA: {
        buttonLabel: displayProgress ? t('Continue') : t('View'),
        href: link.href,
        icon: IconType.Arrow,
        onClick: link.navigate,
      },
    };
  },
  bodyRowsLayout: () => [BodyRowType.Icons],
  headerConfig: ({ t }) => ({
    iconB: lessonIconConfig,
    title: t('Lesson'),
  }),
  iconRowsLayout: ({ hasProgress }) =>
    hasProgress
      ? [[IconLabel.Labs, IconLabel.Quizzes], [IconLabel.Videos]]
      : [[IconLabel.Duration, IconLabel.Level]],
};

export default lessonConfig;
